import api from 'api/api';
import downloadReceipt from 'utils/downloadReceipt';
import { IAccountLookup, IOtherLookupRes, ITransferCharge } from './ToAnotherBank.model';

export const lookupOtherAccount = (accountNumber: string,
  bankCode: string, sourceAccount: string): Promise<IAccountLookup> =>
  api
    .post<IOtherLookupRes>('transfer/otherbank/namelookup', {
      destinationAccount: accountNumber,
      institutionId: bankCode,
      sourceAccount,
    })
    .then((data) => ({ name: data.name, beneficiaryId: data.beneficiaryId }));

export const getReceipt = (transactionID: number) =>
  api.get(`/transaction/receipt?trnxID=${transactionID}`).then(downloadReceipt);

export const getTransferCharge = (amount: string | number, type: string) =>
  api.get<ITransferCharge>(`transfer/otherbank/charge?amount=${amount}&type=${type}`, {}, false, false);
